'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');

/**
 * 스킬 라벨의 루트 컴포넌트입니다.
 * 스킬 아이콘과 텍스트를 포함하는 컨테이너 역할을 합니다.
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {ReactNode} props.children - 자식 요소
 * @param {string} [props.className] - 추가적인 CSS 클래스
 */ const Root = ({ children, className })=>{
    return jsxRuntime.jsx(Box, {
        "data-testid": "design-system-skill-chip",
        className: tailwindMerge.twMerge('flex h-9 w-fit shrink-0 select-none items-center gap-2 rounded-xl border border-w-gray-200 py-[5px] pl-[7px] pr-[15px]', className),
        children: children
    });
};
/**
 * 스킬 라벨에 표시되는 아이콘 컴포넌트입니다.
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {string} props.iconUrl - 아이콘 이미지의 URL
 * @param {string} [props.className] - 추가적인 CSS 클래스
 */ const Icon = ({ className, iconUrl })=>{
    return jsxRuntime.jsx("img", {
        "data-testid": "design-system-skill-chip--icon",
        src: iconUrl,
        alt: "icon",
        width: 24,
        height: 24,
        className: tailwindMerge.twMerge('size-6 shrink-0 rounded-full object-cover', className)
    });
};
/**
 * 스킬 라벨에 표시되는 텍스트 컴포넌트입니다.
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {ReactNode} props.children - 표시할 텍스트 내용
 * @param {string} [props.className] - 추가적인 CSS 클래스
 */ const Text = ({ children, className })=>{
    return jsxRuntime.jsx(Typography, {
        variant: "body2",
        className: tailwindMerge.twMerge('text-w-gray-900', className),
        children: children
    });
};

exports.Icon = Icon;
exports.Root = Root;
exports.Text = Text;
